export default __webpack_public_path__ + "files/NoSignificantTrendIcon-fec7c9c68ff7ba95e6f588f45e2aa3d9.png";